import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MonetaryValueResponse } from '../../api/core/models/api/monetary-value-response';
import { ClientParameterDetails } from '../../model/client-model/client-parameter';
import { ClientVariable } from '../../model/client-model/client-variable';
import { CommentSaveEnvelope, VariableSaveEnvelope } from '../../services/store/inventories/inventories-facade.types';
import { InventoryUpdate } from '../../services/store/inventories/inventory-save-manager.service';
import { InventoriesState, Variable } from './inventories.types';

export const inventoriesEffectsActions = createActionGroup({
  source: 'Inventories Effects',
  events: {
    'Load inventories start': emptyProps(),
    'Loaded inventories': props<{ inventories: InventoriesState['inventories'] }>(),
    'Loading inventories failed': props<{ error: Error }>(),
    'Reset inventories': emptyProps(),
    'Save inventory monetary value': props<{ inventoryId: string; monetaryValue: MonetaryValueResponse }>(),
    'Saved inventory monetary value': props<{ monetaryValue: MonetaryValueResponse }>(),
    'Saving inventory value failed': props<{ error: Error }>(),
    'Saving inventory': props<{ inventoryId: string }>(),

    // deprecated, will be removed once all old inventory components are removed
    'Loaded variable logs': props<{
      valueId: ClientVariable['valueId'];
      variableDetails: ClientParameterDetails;
    }>(),
    'Loading variable logs failed': props<{ error: Error }>(),
    'Save variable': props<{ variableSaveEnvelope: VariableSaveEnvelope & { saveId: string } }>(),
    'Save queued variable': props<{ variableSaveEnvelope: VariableSaveEnvelope & { saveId: string } }>(),
    'Saved variable': props<{ variable: Variable & { saveId: string; queueId: string } }>(),
    'Saving variable failed': props<{ error: Error; queueId: string }>(),
    'Queue variable save': props<{ variableSaveEnvelope: VariableSaveEnvelope & { saveId: string } }>(),
    'Reload inventory mismatch': props<{ variableSaveEnvelope: VariableSaveEnvelope & { saveId: string } }>(),
    'Reload inventory mismatch success': props<{
      variableSaveEnvelope: VariableSaveEnvelope & { saveId: string };
      variables: Variable[];
      inventoryId: string;
    }>(),
  },
});

export const inventoriesFacadeActions = createActionGroup({
  source: 'Inventories Facade',
  events: {
    'Load variable logs': props<{ variableNameId: string; inventoryId: string; id: string }>(),
    'Save inventory monetary value': props<{ inventoryId: string; monetaryValue: MonetaryValueResponse }>(),
    'Save inventory value': props<InventoryUpdate>(),
    // deprecated
    'Add monetary variable IDs': props<{ ids: Map<string, boolean> }>(),
    'Create value comment': props<{ commentSaveEnvelope: CommentSaveEnvelope }>(),
    'Save variable': props<{ variableSaveEnvelope: VariableSaveEnvelope & { saveId: string } }>(),
  },
});

export const inventorySaveManagerActions = createActionGroup({
  source: 'Inventory Save Manager',
  events: {
    'Save inventory value success': props<{ values: InventoryUpdate[] }>(),
    'Save inventory value error': props<{ values: InventoryUpdate[] }>(),
  },
});
